export default [
  'ausgschammt',
  'bläd',
  'bsuffa',
  'dammisch',
  'daschissn',
  'dasoacht',
  'dabrunzt',
  'deppat',
  'dirr',
  'fad',
  'fett',
  'fischaugad',
  'foisch',
  'gamsig',
  'giftig',
  'glumpad',
  'greislig',
  'gschamig',
  'gschlampad',
  'gschleckerd',
  'gschleckt',
  'großkopfad',
  'gwambad',
  'hinterfotzig',
  'hoaklad',
  'hoorig',
  'lackiert',
  'letscherd',
  'mistig',
  'ogsoacht',
  'oid',
  'oreidig',
  'ruachad',
  'schiach',
  'schiaglad',
  'windig',
  'zahnluckad',
  'zamgschissn',
  'zamgsuffa',
  'zwida',
] as string[];
